const INIT_FILTER_VALUE = {
  hcm: null,
  organize: null,
  sub_organize: null,
  province: null,
};

const state = () => {
  return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
  clearStore({ commit }) {
    commit("clearStore");
  },
  setStore({ commit }, store) {
    commit("setStore", store);
  },
  setHcm({commit}, hcm){
    commit("setHcm", hcm)
  }
};

// mutations
const mutations = {
  clearStore(state) {
    state = { ...INIT_FILTER_VALUE };
  },
  setStore(state, store) {
    Object.assign(state, store);
  },
  setHcm(state, hcm){
    state.hcm = hcm
  }
};
const getters = {
  getAllFilter: (state) => {
    return state;
  },
  getFilterSummaryArray: (state) => {
    let prepareState = { ...state };
    let result = [];
    if (prepareState.hcm)
      result.push({
        title: "HCM",
        text: prepareState.hcm,
      });
    if (prepareState.organize)
      result.push({
        title: "หน่วยงาน",
        text: prepareState.organize.AGC_NAME,
      });
    if (prepareState.sub_organize)
      result.push({
        title: "หน่วยงานย่อย",
        text: prepareState.sub_organize.ORG_NAME,
      });
    if (prepareState.province)
      result.push({
        title: "จังหวัด",
        text: prepareState.province.province_name,
      });
    return result;
  },
  getFilterForApi: (state) => {
    const result = {};
    if (state.hcm) result.hcm_uid = state.hcm;
    if (state.organize) result.agc = state.organize.AGC_CODE.toString();
    if (state.sub_organize) result.org = state.sub_organize.ORG_CODE.toString();
    if (state.province) result.prov = state.province._id.province_ID.toString();
    return result;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
